<gstar-external-users-grid
  [source]="externalUsers()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)"
  (deleteRequested)="onDeleteUserRequested($event)" />
